import styled from 'astroturf/react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { dismissValidationError } from 'actions/errors'
import { inviteeFullNameErrorsSelector } from 'selectors'
import BookingField from 'components/enter_details/booking_field'
import BookingTextField from 'components/form/text'
import { useI18n } from 'locales'

import { usePurchasedPackageData } from '../../../../../hooks/usePurchasedPackageData'
import { eventTypeSelector } from '../../../../../root-api'
import _TextField from "combined_name_input-TextField.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/scheduling_form_feature/invitee_inputs/combined_name_input.js?styleId=TextField";


const TextField = /*#__PURE__*/styled(BookingTextField, null, {
  displayName: "TextField",
  styles: _TextField
})
const CombinedNameInput = ({ fullName, onChange }) => {
  const { i18n } = useI18n()
  const fullNameErrors = useSelector(inviteeFullNameErrorsSelector)
  const { uuid } = useSelector(eventTypeSelector)
  const { purchasedPackage } = usePurchasedPackageData(uuid)
  const dispatch = useDispatch()
  const dismissError = () => dispatch(dismissValidationError('invitee', 'full_name'))

  const handleChange = (...args) => {
    dismissError()
    onChange(...args)
  }

  if (!(fullName)) return null

  const disable = Boolean(purchasedPackage)

  return (
    <BookingField>
      <TextField
        id="full_name_input"
        label={i18n.t('booking.templates.name')}
        name="full_name"
        value={fullName.value}
        maxLength={155}
        required={fullName.required}
        onChange={handleChange}
        error={fullNameErrors?.[0]}
        autoComplete="name"
        disabled={disable}
      />
    </BookingField>
  )
}

CombinedNameInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  fullName: PropTypes.shape({
    value: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired
  })
}

export default CombinedNameInput
